import { TypedDocumentNode, gql } from '@apollo/client';
import { useCallback } from 'react';

import useMutation from 'hooks/graphql/useMutation';

import {
  CreateEphemeralLink,
  CreateEphemeralLinkVariables,
} from './__generated__/useEphemeralLink.graphql';

const CREATE_EPHEMERAL_LINK_MUTATION = gql`
  mutation CreateEphemeralLink($input: createEphemeralLinkInput!) {
    createEphemeralLink(input: $input) {
      url
      errors {
        message
      }
    }
  }
` as TypedDocumentNode<CreateEphemeralLink, CreateEphemeralLinkVariables>;

export default () => {
  const [mutate] = useMutation(CREATE_EPHEMERAL_LINK_MUTATION);

  return useCallback(
    async (url: string) => {
      const res = await mutate({
        variables: { input: { url, tokenAsQueryParam: false } },
      });

      return res.data?.createEphemeralLink?.url;
    },
    [mutate]
  );
};
